import React, { FC } from 'react';
import { Box } from '@wix/design-system';
import s from './CarouselStudioBranding.module.scss';
import StudioLogo from '../../../../assets/images/StudioLogo';

interface Props {
  isMobileView?: boolean;
}

const CarouselStudioBranding: FC<Props> = ({ isMobileView }) => {
  return (
    <Box
      className={isMobileView ? s.logoBackgroundMobile : s.logoBackground}
      width="73px"
      height="19px"
      verticalAlign="middle"
      align="center"
    >
      <Box>
        <StudioLogo />
      </Box>
    </Box>
  );
};

export default CarouselStudioBranding;
